// extracted by css-extract-rspack-plugin
export default {"sectionLabel":"sectionLabel-QfpY7_","sectionTitle":"sectionTitle-FTfI3e","fieldLabel":"fieldLabel-iLt39F","fieldLabelSpaced":"fieldLabelSpaced-Oc4mKy"};